import React, { useState, useEffect } from 'react';
import './Adduser.css';
import '../Teachers/Teachers.css';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogContent from '@material-ui/core/DialogContent';
import MuiDialogActions from '@material-ui/core/DialogActions';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import { apiPath, apiKey } from '../../constants';

const styles = (theme) => ({
    root: {
        margin: 0,
        padding: theme.spacing(2),
    },
    closeButton: {
        position: 'absolute',
        right: theme.spacing(1),
        top: theme.spacing(1),
        color: theme.palette.grey[500],
    },
});

const DialogTitle = withStyles(styles)((props) => {
    const { children, classes, onClose, ...other } = props;
    return (
        <MuiDialogTitle disableTypography className={classes.root} {...other}>
            <Typography variant="h6">{children}</Typography>
            {onClose ? (
                <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
                    <CloseIcon />
                </IconButton>
            ) : null}
        </MuiDialogTitle>
    );
});

const DialogContent = withStyles((theme) => ({
    root: {
        padding: theme.spacing(2),
    },
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
    root: {
        margin: 0,
        padding: theme.spacing(1),
    },
}))(MuiDialogActions);

const useStyles = makeStyles((theme) => ({
    root: {
        '& > *': {
            margin: theme.spacing(1),
            width: '50ch',
        },
    },
}));

function AddUser() {

    const [emailstatus, setEmailStatus] = useState(true);
    const [usernamestatus, setUsernameStatus] = useState(true);
    const [allschool, setAllSchool] = useState([]);
    const [schoolname, setSchoolname] = useState();
    const [schooldetails, setSchooldetails] = useState([]);
    const [isloading, setIsloading] = useState(true);
    const [allschoolAdmin, setallSchoolAdmin] = useState([]);
    const [open, setOpen] = useState(false);
    const [popuomsg, setPopupmsg] = useState(false);
    const [message, setMessage] = useState('');
    const [msgstatus, setMsgstatus] = useState();
    const [phValidation, setPhValidation] = useState(false);
    const [openEdit, setOpenEdit] = useState(false);
    const [isActive, editIsactive] = useState(true);
    const [admfirstname, setAdmFirstName] = useState('');
    const [admsecondname, setAdmSecondName] = useState('');
    const [singleAdminDetails, setsingleAdminDetails] = useState()
    let validationStatus = true

    useEffect(() => {
        initalApiCallFetchAdminData();
    }, [])

    const initalApiCallFetchAdminData = () => {
        async function fetchAdminData() {
            const response = await fetch(apiPath + 'users/roles/ADMN', {
                method: 'GET',
                headers: new Headers({
                    'Content-Type': 'application/json',
                    'x-api-key': apiKey
                }),
            })
            const result = await response.json();
            console.log(result)
            setIsloading(false)
            setallSchoolAdmin(result)
            fetchSchoolData()
        }
        fetchAdminData();
    }

    const fetchSchoolData = () => {
        fetch(apiPath + 'schools', {
            method: 'GET',
            headers: new Headers({
                'Content-Type': 'application/json',
                'x-api-key': apiKey
            }),
        })

            .then(response => response.json())
            .then(data => {
                sortSchools(data)
                setSchooldetails(data)
            })
            .catch(error => console.log(error));
    }

    const sortSchools = (schools) => {
        var schoolArray = [];
        for (var i = 0; i < schools.length; i++) {
            schoolArray.push(schools[i].school_name)
        }
        setAllSchool(schoolArray)
    }

    const handleClickOpen = () => {
        setOpen(true);
    };
    const handleClose = () => {
        setOpen(false);
    };

    const srtingEmptyCheck = (strValue) => {
        return (!strValue.trim().length) ? false : true;
    }

    const nameValidation = (field_id) => {
        let name = ''
        if(field_id === 'fname_error') {
            name = document.getElementById("fname").value;
        }
        if (field_id === 'sname_error') {
            name = document.getElementById("sname").value;
        }
        if(field_id === 'firstName_error'){
            name = document.getElementById("first_name").value;
        }
        if(field_id === 'lastName_error'){
            name = document.getElementById("last_name").value;
        }


        if ((srtingEmptyCheck(name) === false) || (validateNameHasNumber(name) === false)) {
            document.getElementById(field_id).innerHTML = "<span style='color:red;'>Please enter a vaild name</span>";
            validationStatus = false
        }
        else {
            document.getElementById(field_id).innerHTML = "<span></span>";
        }
    }

    function phonenoValidation(phoneno) {
        const regex = /^[(]{0,1}[0-9]{3}[)]{0,1}[-\s\.]{0,1}[0-9]{3}[-\s\.]{0,1}[0-9]{4}$/;
        if (regex.test(phoneno) === false) {
            setPhValidation(false)
            document.getElementById("phone_error").innerHTML = "<span style='color:red;'>Please enter a vaild phone number</span>";
        }
        else {
            setPhValidation(true)
            document.getElementById("phone_error").innerHTML = "<span></span>";
        }
    }

    const validateEmail = (email) => {
        const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(String(email).toLowerCase());
    }

    const checkValidity = (FirstName, SecondName, UserName, Password, Email, phoneNumber, designation) => {
        return (srtingEmptyCheck(FirstName) && srtingEmptyCheck(SecondName) && srtingEmptyCheck(designation) &&
            srtingEmptyCheck(phoneNumber) && srtingEmptyCheck(UserName) && srtingEmptyCheck(Password) && validateEmail(Email)) ? true : false
    }

    const emailCheck = (ID) => {
        if (validateEmail(ID) === false) {
            document.getElementById("email_error").innerHTML = "<span style='color:red;'>Please enter a vaild email id</span>";
            setEmailStatus(false)
        }
        else {
            var url = apiPath + 'users/schools/user/email/' + ID
            fetch(url, {
                method: 'GET',
                headers: new Headers({
                    'Content-Type': 'application/json',
                    'x-api-key': apiKey
                }),
            })
                .then(response => response.json())
                .then(data => {
                    console.log(data)
                    if (data.status === "failed") {
                        setEmailStatus(false)
                        document.getElementById("email_error").innerHTML = "<span style='color:red;'>This email id already used</span>"
                    } else {
                        setEmailStatus(true)
                        document.getElementById("email_error").innerHTML = "<span style='color:red;'></span>"
                    }
                })
                .catch(error => {
                    console.log('There was an error!', error);
                });
        }
    }

    const UsernameCheck = (username) => {

        function hasWhiteSpace(s) {
            return s.indexOf(' ') >= 0;
          }

        if (srtingEmptyCheck(username) === false) {
            document.getElementById("user_error").innerHTML = "<span style='color:red;'>Please enter a vaild user name</span>";
            setUsernameStatus(false)
        }
        if (hasWhiteSpace(username) === true){
            document.getElementById("user_error").innerHTML = "<span style='color:red;'>space character is not permitted in username</span>";
            setUsernameStatus(false)
        }
        else {
            document.getElementById("user_error").innerHTML = "<span></span>";
            var url = apiPath + 'users/schools/user/username/' + username
            fetch(url, {
                method: 'GET',
                headers: new Headers({
                    'Content-Type': 'application/json',
                    'x-api-key': apiKey
                }),
            })
                .then(response => response.json())
                .then(data => {
                    console.log(data)
                    if (data.status === "failed") {
                        setUsernameStatus(false)
                        document.getElementById("user_error").innerHTML = "<span style='color:red;'>This username already used</span>"
                    } else {
                        setUsernameStatus(true)
                        document.getElementById("user_error").innerHTML = "<span style='color:red;'></span>"
                    }
                })
                .catch(error => {
                    console.log('There was an error!', error);
                });
        }
    }

    const submitUser = () => {

        var schoolId
        var FirstName = document.getElementById("fname").value;
        var SecondName = document.getElementById("sname").value;
        var Email = document.getElementById("email").value;
        var UserName = document.getElementById("uname").value;
        var Password = document.getElementById("password").value;
        var phoneNumber = document.getElementById("phoneno").value;
        var designation = document.getElementById("designation").value;
        

        if (schoolname === undefined) {
            schoolId = schooldetails[0].school_code
        } else {
            for (var i = 0; i < schooldetails.length; i++) {
                if (schooldetails[i].school_name === schoolname) {
                    schoolId = schooldetails[i].school_code
                    break;
                }
            }
        }

        console.log(schoolId)

        if((srtingEmptyCheck(UserName) === false)){
            document.getElementById("user_error").innerHTML = "<span style='color:red;'>Please enter a vaild username</span>";
        }

        // if ((srtingEmptyCheck(FirstName) === false) || (validateNameHasNumber(FirstName) === false)){
        //     document.getElementById("fname_error").innerHTML = "<span style='color:red;'>Please enter a vaild name</span>";
        //     validationStatus = false
        // }
        // else {
        //     document.getElementById("fname_error").innerHTML = "<span></span>";
        // }
        // if ((srtingEmptyCheck(SecondName) === false) || (validateNameHasNumber(SecondName) === false)) {
        //     document.getElementById("sname_error").innerHTML = "<span style='color:red;'>Please enter a vaild name</span>";
        //     validationStatus = false
        // }
        // else {
        //     document.getElementById("sname_error").innerHTML = "<span></span>";
        // }
        if (srtingEmptyCheck(Password) === false) {
            document.getElementById("pass_error").innerHTML = "<span style='color:red;'>Please enter a vaild password</span>";
        }
        else {
            document.getElementById("pass_error").innerHTML = "<span></span>";
        }
        if ((srtingEmptyCheck(designation) === false) || (validateNameHasNumber(designation) === false)){
            document.getElementById("designation_error").innerHTML = "<span style='color:red;'>Please enter a vaild designation</span>";
            validationStatus = false
        }
        else {
            document.getElementById("designation_error").innerHTML = "<span></span>";
        }

        if (validationStatus && emailstatus && usernamestatus && phValidation && checkValidity(FirstName, SecondName, UserName, Password, Email, phoneNumber, designation)) {
            setIsloading(true)
            const requestOptions = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'x-api-key': apiKey },
                body: JSON.stringify({
                    "class_code": "dummy",
                    "email": Email,
                    "first_name": FirstName,
                    "is_active": 1,
                    "last_name": SecondName,
                    "role_code": "ADMN",
                    "username": UserName,
                    "password": Password,
                    "designation": designation,
                    "contact_number": phoneNumber,
                    "school_name": schoolname,
                    "country_code": "India",
                    "language": "English"
                })
            };
            fetch(apiPath + 'users/schools/' + schoolId + '/user/admin', requestOptions)
                .then(response => response.json())
                .then(data => {
                    console.log(data)
                    setIsloading(false)
                    if (data.status === "success") {
                        togglePopUpOpen(1, data.message)
                    } else {
                        togglePopUpOpen(2, data.message)
                    }
                    initalApiCallFetchAdminData();
                })
                .catch(error => {
                    console.error('There was an error!', error);
                });
            console.log("here")
        }
    }

    const togglePopUpOpen = (status, data) => {
        handleClose()
        setMsgstatus(status);
        setMessage(data);
        setPopupmsg(true);
    }

    const togglePopUpClose = () => {
        setPopupmsg(false);
    }

    const toggleisActiveSwitch = () => {
        editIsactive(!isActive)
    }

    const handleAdmineDetailsOpen = (admindetails) => {
        // console.log(admindetails)
        setsingleAdminDetails(admindetails)
        setAdmFirstName(admindetails.first_name)
        setAdmSecondName(admindetails.last_name)
        if (admindetails.is_active === 1) {
            editIsactive(true)
        }
        else {
            editIsactive(false)
        }
        setOpenEdit(true)
    }

    const handleAdminDetailsClose = () => {
        document.getElementById("firstName_error").innerHTML = "<span></span>";
        document.getElementById("lastName_error").innerHTML = "<span></span>";
        setOpenEdit(false)
    }

    const editAdminDetailsApiCall = () => {

        // let firstname_status = false
        // let lastname_status = false

        var firstName = document.getElementById("first_name").value;
        var lastName = document.getElementById("last_name").value;

        // if ((srtingEmptyCheck(firstName) === false) || (validateNameHasNumber(firstName) === false)) {
        //     document.getElementById("firstName_error").innerHTML = "<span style='color:red'>Please enter a vaild name</span>";
        // }
        // else {
        //     document.getElementById("firstName_error").innerHTML = "<span></span>";
        //     firstname_status = true
        // }
        // if ((srtingEmptyCheck(lastName) === false) || (validateNameHasNumber(lastName) === false)) {
        //     document.getElementById("lastName_error").innerHTML = "<span style='color:red'>Please enter a vaild name</span>";
        // }
        // else {
        //     document.getElementById("lastName_error").innerHTML = "<span></span>";
        //     lastname_status = true
        // }

        if (validationStatus) {

            console.log()
            var active
            if (isActive === true) {
                active = '1'
            } else {
                active = '0'
            }

            const requestOptions = {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-api-key': apiKey
                },
                body: JSON.stringify({
                    "first_name": admfirstname,
                    "last_name": admsecondname,
                    "is_active": active,
                    "role_code": "ADMN"
                })
            };
            fetch(apiPath + 'users/schools/' + singleAdminDetails.school.school_code + '/user/' + singleAdminDetails.username + '/admin/update', requestOptions)
                .then(response => response.json())
                .then(data => {
                    console.log(data)
                    if (data.status === "success") {
                        togglePopUpOpen(1, data.message)
                    } else {
                        togglePopUpOpen(2, data.message)
                    }
                    initalApiCallFetchAdminData();
                    setOpenEdit(false)
                })
                .catch(error => {
                    console.log('There was an error!', error);
                });
        }
    }

    const validateNameHasNumber = (name) => {
        let hasNumber = /^[a-zA-Z\s]*$/;
        if (hasNumber.test(name) === false) {
            return false
        }
        else {
            return true
        }
    }

    const resetPassword = () => {

        let firstname_status = false
        let lastname_status = false

        var firstName = document.getElementById("first_name").value;
        var lastName = document.getElementById("last_name").value;

        if ((srtingEmptyCheck(firstName) === false) || (validateNameHasNumber(firstName) === false)) {
            document.getElementById("firstName_error").innerHTML = "<span style='color:red'>Please enter a vaild name</span>";
        }
        else {
            document.getElementById("firstName_error").innerHTML = "<span></span>";
            firstname_status = true
        }
        if ((srtingEmptyCheck(lastName) === false) || (validateNameHasNumber(lastName) === false)) {
            document.getElementById("lastName_error").innerHTML = "<span style='color:red'>Please enter a vaild name</span>";
        }
        else {
            document.getElementById("lastName_error").innerHTML = "<span></span>";
            lastname_status = true
        }

        if (firstname_status && lastname_status) {
            const requestOptions = {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-api-key': apiKey
                },
                body: JSON.stringify({
                })
            };
            fetch(apiPath + 'users/schools/' + singleAdminDetails.school.school_code + '/user/' + singleAdminDetails.username + '/resetpassword', requestOptions)
                .then(response => response.json())
                .then(data => {
                    if (data.status === "success") {
                        togglePopUpOpen(1, data.message + '\n The new password is : ' + data['new_password'])
                    } else {
                        togglePopUpOpen(2, data.message)
                    }
                    initalApiCallFetchAdminData();
                    setOpenEdit(false)
                })
                .catch(error => {
                    console.log('There was an error!', error);
                });
        }
    }

    return (
        <div className="CourseClassesmain">
            <div className="adduser_buttonmain" onClick={handleClickOpen}>
                Add School Admin
            </div>
            {
                isloading ?
                    <img className="loadingSymbol" src={require('../../images/loading2.gif')} alt="loading" />
                    :
                    <div className="fixTableHead">
                        <table>
                            <thead>
                                <tr>
                                    <th>No.</th>
                                    <th>School</th>
                                    <th>Admin</th>
                                    <th>Email</th>
                                    <th>User Name</th>
                                    <th>Update User</th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    allschoolAdmin && allschoolAdmin.map((admindetails, index) => {
                                        return (
                                            <tr key={admindetails.user_id}>
                                                <td>{index + 1}</td>
                                                <td>{admindetails.school.school_name}</td>
                                                <td>{admindetails.first_name}&nbsp;{admindetails.last_name}</td>
                                                <td>{admindetails.email}</td>
                                                <td>{admindetails.username}</td>
                                                <td><div className="admin-CourseCls_assign" onClick={() => handleAdmineDetailsOpen(admindetails)} >Edit Profile</div></td>
                                            </tr>
                                        )
                                    })
                                }
                            </tbody>
                        </table>
                    </div>
            }
            <div>
                <Dialog onClose={handleClose} aria-labelledby="customized-dialog-title" open={open}>
                    <DialogTitle id="customized-dialog-title" onClose={handleClose}>
                        Admin Details
                    </DialogTitle>
                    <DialogContent dividers>
                        <div style={{
                            pointerEvents: (isloading === true) ? 'none' : 'auto'
                        }}>
                            <div>
                                <img className={isloading === true ? "loadingSymbol_new" : "loadingSymbol_none"} src={require('../../images/loading2.gif')} alt="loading" />
                            </div>
                            <form autoComplete="off" style={{ padding: '0vw 4vw' }}>
                                <input id="fname"
                                    className="input_registration"
                                    type="text"
                                    placeholder="First Name" 
                                    onBlur={e => nameValidation('fname_error')}/>
                                <div className="fname_name" id='fname_error'></div>
                                <input id="sname"
                                    className="input_registration"
                                    type="text"
                                    placeholder="Last Name" 
                                    onBlur={e => nameValidation('sname_error')}/>
                                <div className="sname_name" id='sname_error'></div>
                                <div className="class_techer_select">
                                    <div className="class_techer_select_heading">Select School</div>
                                    <select className="class_techer_dropdown"
                                        value={schoolname}
                                        onChange={e => setSchoolname(e.target.value)}
                                        onBlur={e => setSchoolname(e.target.value)}>
                                        {
                                            allschool && allschool.map((schoolname, index) => {
                                                return (
                                                    <option key={index} value={schoolname}>
                                                        {schoolname}
                                                    </option>
                                                );
                                            })}
                                    </select>
                                </div>
                                <input id="phoneno" className="input_registration" type="text"
                                    onBlur={e => phonenoValidation(e.target.value)}
                                    placeholder="Phone number" />
                                <div className="sname_name" id='phone_error'></div>
                                <input id="designation" className="input_registration"
                                    type="text" placeholder="Designation" 
                                    onBlur={() => document.getElementById('designation_error').innerHTML = "<span></span>"}/>
                                <div className="sname_name" id='designation_error'></div>
                                <input id="email"
                                    className="input_registration"
                                    type="text"
                                    onBlur={e => emailCheck(e.target.value)}
                                    placeholder="Email" />
                                <div className="sname_name" id='email_error'></div>
                                <input id="uname"
                                    className="input_registration"
                                    type="text"
                                    onBlur={e => UsernameCheck(e.target.value)}
                                    placeholder="User Name" />
                                <div className="sname_name" id='user_error'></div>
                                <input id="password" className="input_registration" 
                                type="password" placeholder="Password" autoComplete="new-password"
                                onBlur={() => document.getElementById('pass_error').innerHTML = "<span></span>"} />
                                <div className="sname_name" id='pass_error'></div>
                            </form>
                        </div>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={submitUser} color="primary"> Create </Button>
                    </DialogActions>
                </Dialog>
            </div>
            <div className={`popUpModalBackground popUpmodalShowing-${popuomsg}`}>
                {
                    (msgstatus && msgstatus === 1) ?
                        <div>
                            <div className="popUpModal-success">
                                <img className="popUpModal-successimg" src={require('../../images/success.png')} />
                            </div>
                            <div className="popUpModal-Content">
                                {message}
                                <div className="popUpModal-submitOutter">
                                    <div className="popUpModal-submitInner" onClick={() => togglePopUpClose()}>close</div>
                                </div>
                            </div>
                        </div>
                        :
                        <div>
                            <div className="popUpModal-success">
                                <img className="popUpModal-successimg" src={require('../../images/warning.png')} />
                            </div>
                            <div className="popUpModal-Content">
                                {message}
                                <div className="popUpModal-submitOutter">
                                    <div className="popUpModal-submitInner" onClick={() => togglePopUpClose()}>close</div>
                                </div>
                            </div>
                        </div>
                }
            </div>
            <div className={`editAdminModalBackground editAdminmodalShowing-${openEdit}`}>
                <div className="editmodal_close_img_div">
                    <img onClick={handleAdminDetailsClose} className="editmodal_close" src={require('../../images/close.png')} />
                </div>
                <div className="editTeacherHeading">Edit Admin Details</div>
                <div className="std-edit_resetpassword_outter">
                    {
                        isActive && isActive === true ?
                            <img className="std-edittogglebutton" onClick={() => toggleisActiveSwitch()}
                                src={require('../../images/switch.png')} />
                            :
                            <img className="std-edittogglebutton" onClick={() => toggleisActiveSwitch()}
                                src={require('../../images/switchoff.png')} />
                    }
                    <div className="std-editactive">
                        Active :
                    </div>
                </div>
                <div className="adm-editModalBackground_outter">
                    <form autoComplete="off" className="adm-edit_input_outter">
                        <div>
                            <input id="first_name" className="std-edit_input_teachers" type="text" placeholder="First Name"
                                value={admfirstname} onChange={e => setAdmFirstName(e.target.value)}
                                onBlur={e => nameValidation('firstName_error')}/>
                            <div align="left" id='firstName_error'></div>
                            <input id="last_name" className="std-edit_input_teachers" type="text" placeholder="Last Name"
                                value={admsecondname} onChange={e => setAdmSecondName(e.target.value)}
                                onBlur={e => nameValidation('lastName_error')}/>
                            <div align="left" id='lastName_error'></div>
                        </div>
                    </form>
                </div>
                <div className="std-edit_resetpassword_outter">
                    <div className="edit_resetpassword_btn" onClick={() => resetPassword()}>Reset Password</div>
                    <div className="edit_resetpassword_btn" onClick={() => editAdminDetailsApiCall()}>Update</div>

                </div>
            </div>
        </div>
    );
}

export default AddUser;